export const formatPeriodFieldLabel = (t, translationKey, index) => {
  const periodLabel = t('DATE_SCENARIO_MODAL_PERIOD_LABEL', { index });
  const template = t(translationKey, { period: periodLabel });

  if (typeof template !== 'string') {
    return periodLabel;
  }

  return template.replace(/{{\s*period\s*}}/gi, periodLabel);
};


